export const category = [
  { key: 'devanti', text: 'Devanti', value: 'Devanti' },
    { key: 'artiss', text: 'Artiss', value: 'Artiss' },
    { key: 'everfit', text: 'Everfit', value: 'Everfit' },
    {key: 'gisellebedding', text: 'Giselle Bedding', value: 'Giselle Bedding'},
    { key: 'cefito', text: 'Cefito', value: 'Cefito' },
    { key: 'weisshorn', text: 'Weisshorn', value: 'Weisshorn' },
    { key: 'i.Pet', text: 'i.Pet', value: 'i.Pet' },
    {key: 'keezi', text: 'Keezi', value: 'Keezi'}
  ];